var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-page"},[(_vm.imageUrl)?_c('img',{staticClass:"banner-image",attrs:{"src":_vm.imageUrl,"alt":""}}):_c('div',{staticClass:"not-img"},[_vm._v("没什么可看的内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }